export const PROPERTY_CHAT_FILE_UPLOAD_MAX_FILES = 7;